import styled from 'styled-components'
import colours from '../lib/colours'

const linkColors: any = {
  dark: {
    color: colours.darkPurple,
    hoverColor: colours.mediumPurple
  },
  light: {
    color: colours.white,
    hoverColor: colours.white
  }
}

export default (element: any, mode: string) =>
  styled(element)`
    color: ${linkColors[mode].color};
    font-weight: 300;
    cursor: pointer;
    text-decoration: underline;
    :hover {
      color: ${linkColors[mode].hoverColor};
      text-decoration: underline;
    }
  `
